module.exports = __webpack_public_path__ + "static/img/AllInOne6.cbeafb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne6.png
// module id = TWR+
// module chunks = 2